import { UnitCaracType } from '@Models';

export class UnitCaracView {
  type: UnitCaracType;
  adv: string | null;
  mar: string | null;
  dis: string | null;
  evoked: string | null;
  hp: string | null;
  def: string | null;
  res: string | null;
  arm: string | null;
  aeg: string | null;
  flyAdv: string | null;
  flyMar: string | null;
  base: string;
  height: string;
  unitType: string;

  constructor(params: UnitCaracParams) {
    this.type = params.type ?? UnitCaracType.V1;
    this.adv = params.adv ?? null;
    this.mar = params.mar ?? null;
    this.dis = params.dis ?? null;
    this.evoked = params.evoked ?? null;
    this.hp = params.hp ?? null;
    this.def = params.def ?? null;
    this.res = params.res ?? null;
    this.arm = params.arm ?? null;
    this.aeg = params.aeg ?? null;
    this.flyAdv = params.flyAdv ?? null;
    this.flyMar = params.flyMar ?? null;
    this.base = params.base;
    this.height = params.height;
    this.unitType = params.unitType;
  }
}

export type UnitCaracParams = {
  type: UnitCaracType | null;
  adv?: string | null;
  mar?: string | null;
  dis?: string | null;
  evoked: string | null;
  hp: string | null;
  def: string | null;
  res: string | null;
  arm: string | null;
  aeg: string | null;
  flyAdv?: string | null;
  flyMar?: string | null;
  base: string;
  height: string;
  unitType: string;
};
